import { useMutation } from 'react-query';
import { useGetTwilioConversationById } from './twilioConversationQueries';

export const useSetAssociateIsTyping = (conversationId?: string) => {
  const { data: conversation } = useGetTwilioConversationById(conversationId);
  return useMutation(['setAssociateIsTyping'], () => {
    if (!conversation) {
      return Promise.resolve(undefined);
    }
    return conversation.typing();
  });
};
